import React, { memo } from 'react'
import { Argument as ClassName } from 'classnames'
import { useParams } from 'react-router-dom'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'

import {
    useChargePointGetAlarmsQuery,
    useChargePointAcknowledgeAlarmMutation,
    Alarm,
} from '../../../common/redux/api/web-api'
import { dateLocalize } from '../../../lib/date-localize'
import useText from '../../../common/hooks/useText'
import { Table } from '../../../common/uikit/Table'
import { Panel } from '../../uikit/Panel'

export type ChargePointAlarmsWidgetProps = {
    className?: ClassName
    style?: React.CSSProperties
}

export const ChargePointAlarmsWidget = memo(function ChargePointAlarmsWidget(): React.ReactElement {
    const text = useText()
    const { chargePointId } = useParams()
    const { data: chargePointAlarmData, isFetching } = useChargePointGetAlarmsQuery({
        chargePointId: chargePointId,
        expand: 'company',
    })

    const [acknowledgeAlarm] = useChargePointAcknowledgeAlarmMutation()

    const setAcknowledge = async (alarm: number) => {
        try {
            await acknowledgeAlarm({
                chargePointId,
                alarmId: alarm,
            }).unwrap()
        } catch (e) {
            console.error(e)
        }
    }

    return (
        <Panel title={text('lblAlarms')} headerIcon={<i className="pi pi-bell"></i>}>
            <Table
                title={text('lblAlarms')}
                value={chargePointAlarmData}
                loading={isFetching}
                paginator
                globalFilterFields={[
                    'alarmDefinition.name',
                    'alarmDefinition.description',
                    'company.name',
                    'chargePointId',
                ]}
                emptyMessage={text('msgNoAlarmsFound')}
            >
                <Column key="alarm-name" field="alarmDefinition.name" header={text('lblName')}></Column>
                <Column
                    key="alarm-time"
                    field="lastOccurence"
                    header={text('lblTime')}
                    body={(alarm) => dateLocalize(alarm.lastOccurence)}
                ></Column>

                <Column
                    key="alarm-description"
                    field="alarmDefinition.description"
                    header={text('lblDescription')}
                ></Column>
                <Column key="alarm-occurrences" field="noOfOccurences" header="#"></Column>
                <Column
                    key="alarm-acknowledged"
                    field="acknowledged"
                    header={text('lblConfirm')}
                    body={(alarm: Alarm) =>
                        alarm.acknowledged ? (
                            <span data-testid="date-checked">{dateLocalize(alarm.acknowledged)}</span>
                        ) : (
                            <Button
                                size="small"
                                rounded
                                data-testid="confirm-icon"
                                icon="pi pi-check"
                                title={text('btnConfirm')}
                                onClick={() => setAcknowledge(alarm.id!)}
                            ></Button>
                        )
                    }
                ></Column>
            </Table>
        </Panel>
    )
})
